import { atom } from 'jotai';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type Margins = Record<string, Margin> | null;

export interface Margin {
  isolatedMarginAvailable: string;
  unrealizedPnl: string;
  usdtReservedForIsolatedMargin: string;
  reservedForIsolatedMargin: string;
  reservedForIsolatedMarginPosition: string;

  marginBalance: string;
  initMarginReserved: string;
  initPositionMargin: string;
  crossMarginAvailable: string;
  crossMarginRatio?: string;
}

export const marginsAtom = atom<Margins>(null);

export const subscribeMarginsBunja = createTableAccumulatorBunja(
  'private/margins',
  (store) => (wsData) => store.set(marginsAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
